import classNames from "classnames";
import { Icon } from "@/comn/components";
import { Logo } from "../Logo";
import { _TEST1234 } from "@/comn/features/config/ApiConfig";

export const NavigationLogo = ({ expanded, setExpanded }: any) => {
    return (
        <div
            className={classNames(
                "flex items-center h-[100px] justify-center",
                "group-aria-expanded:px-8 group-aria-expanded:justify-between",
            )}
        >
            {expanded && (
                <Logo />
            )}
            <button className="p-2" onClick={() => setExpanded((prev: any) => !prev)}>
                <Icon icon={expanded ? "snb_close" : "snb_open"} size="lg" />
            </button>
        </div>
    );
};
